export const GET_DRIVING_DIRECTIONS_LIST = 'GET_DRIVING_DIRECTIONS_LIST';
export const GET_DRIVING_DIRECTIONS_LIST_SUCCESS = 'GET_DRIVING_DIRECTIONS_LIST_SUCCESS';
export const GET_DRIVING_DIRECTIONS_LIST_FAIL = 'GET_DRIVING_DIRECTIONS_LIST_FAIL';

export const GET_DRIVING_DIRECTION = 'GET_DRIVING_DIRECTION';
export const GET_DRIVING_DIRECTION_SUCCESS = 'GET_DRIVING_DIRECTION_SUCCESS';
export const GET_DRIVING_DIRECTION_FAIL = 'GET_DRIVING_DIRECTION_FAIL';

export const POST_DRIVING_DIRECTION = 'POST_DRIVING_DIRECTION';
export const POST_DRIVING_DIRECTION_SUCCESS = 'POST_DRIVING_DIRECTION_SUCCESS';
export const POST_DRIVING_DIRECTION_FAIL = 'POST_DRIVING_DIRECTION_FAIL';

export const PATCH_SELECTED_DRIVING_DIRECTION = 'PATCH_SELECTED_DRIVING_DIRECTION';
export const PATCH_SELECTED_DRIVING_DIRECTION_SUCCESS = 'PATCH_SELECTED_DRIVING_DIRECTION_SUCCESS';
export const PATCH_SELECTED_DRIVING_DIRECTION_FAIL = 'PATCH_SELECTED_DRIVING_DIRECTION_FAIL';

export const DELETE_DRIVING_DIRECTION = 'DELETE_DRIVING_DIRECTION';
export const DELETE_DRIVING_DIRECTION_SUCCESS = 'DELETE_DRIVING_DIRECTION_SUCCESS';
export const DELETE_DRIVING_DIRECTION_FAIL = 'DELETE_DRIVING_DIRECTION_FAIL';

export const REMOVE_DEFAULT_DIRECTION = 'REMOVE_DEFAULT_DIRECTION';
export const REMOVE_DEFAULT_DIRECTION_SUCCESS = 'REMOVE_DEFAULT_DIRECTION_SUCCESS';
export const REMOVE_DEFAULT_DIRECTION_FAIL = 'REMOVE_DEFAULT_DIRECTION_FAIL';

export const CLEAR_SELECTED_DIRECTION = 'CLEAR_SELECTED_DIRECTION';
